import styled, { keyframes } from 'styled-components';

// cor de marca do painel
const BRAND = '#333';
const RED = '#dc2626';
const AMBER = '#92400e';

const spin = keyframes`from { transform: rotate(0); } to { transform: rotate(360deg); }`;

export const Container = styled.div`
  position: relative; background: #fff; border-radius: 10px; width: 100%;
  color: #1f2937; font-family: 'Inter', -apple-system, sans-serif;
  display: flex; flex-direction: column; box-shadow: 0 4px 20px rgba(0,0,0,.06);
`;
export const Header = styled.div`
  padding: 14px 20px; border-bottom: 1px solid #f3f4f6;
  .t { flex: 1; }
  h3 { font-size: 16px; font-weight: 800; color: #111827; margin: 0; }
  p { font-size: 12px; color: #6b7280; margin: 2px 0 0; }
`;
export const Tabs = styled.div`
  display: flex; gap: 4px; padding: 0 20px; border-bottom: 1px solid #f3f4f6;
  button {
    border: none; background: none; padding: 11px 14px; font-size: 13px; font-weight: 700;
    color: #9ca3af; cursor: pointer; border-bottom: 2px solid transparent; font-family: inherit;
    &.active { color: ${BRAND}; border-bottom-color: ${BRAND}; }
  }
`;
export const Body = styled.div`padding: 16px 20px; overflow: auto; flex: 1;`;
export const Footer = styled.div`
  padding: 12px 20px; border-top: 1px solid #f3f4f6; display: flex; gap: 10px; align-items: center;
  .spacer { flex: 1; }
`;
export const Alert = styled.div`
  display: flex; align-items: center; gap: 8px; background: #fef2f2; border: 1px solid #fecaca;
  color: ${RED}; border-radius: 10px; padding: 9px 14px; font-size: 12px; font-weight: 600; margin-bottom: 14px; cursor: pointer;
  &:hover { background: #fee2e2; }
`;
export const Tiles = styled.div`display: flex; gap: 8px; flex-wrap: wrap; margin-bottom: 14px;`;
export const Tile = styled.button`
  flex: 1 1 140px; min-width: 140px; border: 1.5px solid #e5e7eb; border-radius: 10px; padding: 10px 12px; cursor: pointer; background: #fff; text-align: left; font-family: inherit;
  display: flex; flex-direction: column; gap: 3px;
  &.active { border-color: ${BRAND}; background: #f9fafb; box-shadow: inset 0 0 0 1px ${BRAND}; }
  .lb { display: block; font-size: 10px; text-transform: uppercase; letter-spacing: .04em; color: #6b7280; font-weight: 600; line-height: 1.3; }
  .n { display: block; font-size: 20px; font-weight: 800; color: #111827; line-height: 1.15; }
  .v { display: block; font-size: 11px; color: #9ca3af; line-height: 1.2; }
  &.warn .n { color: ${AMBER}; }
  &.danger .n { color: ${RED}; }
`;
export const Filters = styled.div`
  display: flex; flex-wrap: wrap; align-items: center; gap: 8px; margin-bottom: 12px;
  input, select { height: 34px; padding: 0 10px; border: 1.5px solid #e5e7eb; border-radius: 8px; font-size: 12px; font-family: inherit; background: #fff; }
  input:focus, select:focus { outline: none; border-color: ${BRAND}; }
`;
export const Seg = styled.div`
  display: inline-flex; border: 1.5px solid #e5e7eb; border-radius: 8px; overflow: hidden;
  button { border: none; background: #fff; cursor: pointer; padding: 7px 11px; font-size: 12px; font-weight: 600; color: #6b7280; font-family: inherit; }
  button + button { border-left: 1.5px solid #e5e7eb; }
  button.active { background: ${BRAND}; color: #fff; }
`;
export const Chip = styled.span`
  display: inline-flex; align-items: center; gap: 6px; background: #eef2ff; color: #4338ca; border-radius: 999px; padding: 4px 6px 4px 11px; font-size: 12px; font-weight: 600;
  button { border: none; background: #c7d2fe; color: #4338ca; border-radius: 999px; width: 18px; height: 18px; cursor: pointer; display: inline-flex; align-items: center; justify-content: center; }
`;
export const SummaryRight = styled.span`margin-left: auto; font-size: 12px; color: #6b7280;`;

export const TableWrap = styled.div`overflow-x: auto;`;
export const Grid = styled.table`
  width: 100%; border-collapse: collapse; font-size: 12px;
  th { text-align: left; padding: 8px; font-size: 10px; font-weight: 600; color: #6b7280; text-transform: uppercase; letter-spacing: .03em; border-bottom: 1px solid #e5e7eb; background: #fafafa; white-space: nowrap; }
  td { padding: 8px; border-bottom: 1px solid #f3f4f6; color: #1f2937; vertical-align: middle; }
  tr.done td { background: rgba(22,163,74,.06); }
  tr.paidrow td { background: #f8fafc; }
  .num { font-variant-numeric: tabular-nums; text-align: right; white-space: nowrap; }
  .muted { color: #9ca3af; font-size: 11px; max-width: 150px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .final { font-weight: 700; }
  td.days.overdue { color: ${RED}; font-weight: 700; }
  td.actions { white-space: nowrap; text-align: right; }
`;
export const ProjTable = styled(Grid)`
  td { cursor: pointer; }
  tr:hover td { background: #f9fafb; }
  .refnum { font-weight: 800; color: #111827; font-variant-numeric: tabular-nums; }
  .cv { display: block; font-size: 10px; color: #9ca3af; font-weight: 400; }
  td.num { font-weight: 700; }
  td.pgc { color: #16a34a; } td.vcc { color: ${RED}; } td.avc { color: #0369a1; }
`;
export const ProjBar = styled.div`
  display: flex; height: 6px; border-radius: 999px; overflow: hidden; background: #f1f5f9;
  i { display: block; height: 100%; }
`;

export const BtnLink = styled.button`
  height: 26px; padding: 0 9px; border-radius: 6px; cursor: pointer; font-size: 11px; font-weight: 700; display: inline-flex; align-items: center; gap: 4px; font-family: inherit; border: 1.5px solid; vertical-align: middle;
  & + & { margin-left: 5px; }
  &.plain { background: #fff; color: #6b7280; border-color: #e5e7eb; }
  &.interest { background: ${BRAND}; color: #fff; border-color: ${BRAND}; }
  &.boleto { background: #fff; color: #0369a1; border-color: #bae6fd; }
  &:disabled { opacity: .5; cursor: not-allowed; }
`;
export const IconBtn = styled.button`
  width: 26px; height: 26px; padding: 0; justify-content: center; background: #fff; border: 1.5px solid #e5e7eb; border-radius: 6px; cursor: pointer; display: inline-flex; align-items: center; vertical-align: middle; margin-left: 5px;
  &:hover:not(:disabled) { border-color: ${BRAND}; }
  &.seron { background: ${RED}; color: #fff; border-color: ${RED}; }
  &:disabled { opacity: .35; cursor: not-allowed; }
`;
export const Tag = styled.span`
  display: inline-flex; align-items: center; gap: 4px; font-size: 11px; font-weight: 700; border-radius: 6px; padding: 3px 8px; border: 1.5px solid; vertical-align: middle;
  &.done { color: #16a34a; background: #f0fdf4; border-color: #bbf7d0; }
  &.warn { color: ${AMBER}; background: #fffbeb; border-color: #fde68a; }
  &.paid { color: #0369a1; background: #f0f9ff; border-color: #bae6fd; }
  &.late { color: ${RED}; background: #fef2f2; border-color: #fecaca; }
  &.muted { color: #6b7280; background: #f9fafb; border-color: #e5e7eb; }
`;
export const Selo = styled.span`
  display: inline-block; font-size: 9px; font-weight: 800; padding: 2px 5px; border-radius: 4px; margin-right: 3px;
  &.s60 { background: #dcfce7; color: #166534; }
  &.s90 { background: #f5f3ff; color: #6d28d9; }
  &.sser { background: #fef2f2; color: ${RED}; }
  &.sbx { background: #f1f5f9; color: #64748b; }
  &.alert { background: ${RED}; color: #fff; }
`;

export const BulkBar = styled.div`
  display: flex; align-items: center; gap: 8px; background: #111827; color: #fff; border-radius: 10px; padding: 8px 12px; margin-bottom: 10px; font-size: 12px;
  .spacer { flex: 1; }
`;
export const BulkBtn = styled.button`
  height: 30px; padding: 0 12px; border: none; border-radius: 7px; cursor: pointer; font-size: 12px; font-weight: 700; background: #374151; color: #fff; font-family: inherit;
  &.primary { background: #fff; color: #111827; }
  &.danger { background: ${RED}; }
  &:disabled { opacity: .5; cursor: not-allowed; }
`;

export const BtnCancel = styled.button`
  height: 36px; padding: 0 14px; border: 1.5px solid #e5e7eb; border-radius: 8px; cursor: pointer; background: #fff; color: #6b7280; font-size: 12px; font-weight: 600; display: inline-flex; align-items: center; gap: 6px; font-family: inherit;
  &:disabled { opacity: .5; cursor: not-allowed; }
`;
export const BtnPrimary = styled.button`
  height: 36px; padding: 0 16px; border: none; border-radius: 8px; cursor: pointer; background: ${BRAND}; color: #fff; font-size: 12px; font-weight: 700; display: inline-flex; align-items: center; gap: 6px; font-family: inherit;
  &:disabled { opacity: .5; cursor: not-allowed; }
`;
export const BtnSearch = styled(BtnPrimary)`height: 34px;`;

export const Empty = styled.div`text-align: center; padding: 32px 0; color: #9ca3af; font-size: 13px;`;
export const Spinner = styled.span`
  width: 13px; height: 13px; border: 2px solid #e5e7eb; border-top-color: currentColor; border-radius: 999px; animation: ${spin} 1s linear infinite; display: inline-block; vertical-align: middle;
`;

export const DetHead = styled.div`
  display: flex; align-items: center; gap: 12px; margin-bottom: 12px;
  .dettitle { font-size: 14px; color: #111827; display: flex; align-items: center; gap: 8px; }
  .right { margin-left: auto; font-size: 12px; color: #6b7280; }
`;

export const Overlay = styled.div`
  position: fixed; inset: 0; background: rgba(17,24,39,.45); display: flex; align-items: center; justify-content: center; padding: 20px; z-index: 1000;
`;
export const ConfirmCard = styled.div`
  background: #fff; border-radius: 12px; width: 100%; max-width: 440px; box-shadow: 0 10px 40px rgba(0,0,0,.25); overflow: hidden;
  &.wide { max-width: 540px; }
  .head { padding: 15px 18px; border-bottom: 1px solid #f3f4f6; display: flex; align-items: flex-start; gap: 10px; }
  .head .ht { flex: 1; }
  .head h4 { font-size: 15px; font-weight: 800; margin: 0; color: #111827; }
  .head p { font-size: 12px; color: #6b7280; margin: 2px 0 0; }
  .head .x { background: none; border: none; cursor: pointer; color: #9ca3af; display: inline-flex; }
  .rows { padding: 14px 18px; }
  .r { display: flex; justify-content: space-between; align-items: center; padding: 4px 0; font-size: 13px; }
  .r span:first-child { color: #6b7280; }
  .r.total { border-top: 1px solid #e5e7eb; margin-top: 6px; padding-top: 9px; font-weight: 800; }
  .r.total span:last-child { color: ${BRAND}; font-size: 15px; }
  .warnbox { margin: 0 18px 12px; padding: 8px 10px; background: #fffbeb; border: 1px solid #fde68a; border-radius: 8px; font-size: 11px; color: ${AMBER}; }
  .foot { padding: 13px 18px; border-top: 1px solid #f3f4f6; display: flex; gap: 8px; justify-content: flex-end; }
  .mailbody { padding: 10px 18px 4px; max-height: 52vh; overflow-y: auto; }
  .tplcard { display: block; width: 100%; text-align: left; padding: 11px 13px; border: 1.5px solid #e5e7eb; border-radius: 8px; background: #fff; cursor: pointer; margin-bottom: 8px; font-family: inherit; }
  .tplcard:hover { border-color: ${BRAND}; background: #fafafa; }
  .tplcard .tr { display: flex; align-items: center; gap: 8px; }
  .tplcard .tt { font-size: 13px; font-weight: 700; color: #111827; }
  .tplcard .aud { font-size: 10px; font-weight: 600; padding: 2px 6px; border-radius: 999px; }
  .tplcard .aud.aluno { background: #eef2ff; color: #4338ca; }
  .tplcard .aud.equipe { background: #fef3c7; color: ${AMBER}; }
  .seq { display: inline-flex; gap: 4px; padding: 4px; background: #f3f4f6; border-radius: 8px; }
  .seq button { border: none; background: transparent; padding: 5px 10px; border-radius: 6px; font-size: 11px; font-weight: 600; color: #6b7280; cursor: pointer; }
  .seq button.active { background: #fff; color: ${BRAND}; box-shadow: 0 1px 3px rgba(0,0,0,.08); }
`;
export const SendRow = styled.div`
  display: flex; gap: 8px; padding: 8px 18px 14px;
  .s { flex: 1; height: 38px; border-radius: 8px; font-size: 12px; font-weight: 700; cursor: pointer; border: 1.5px solid; display: inline-flex; align-items: center; justify-content: center; gap: 6px; font-family: inherit; }
  .s.real { background: ${BRAND}; color: #fff; border-color: ${BRAND}; }
  .s.test { background: #fff; color: #374151; border-color: #e5e7eb; }
  .s:disabled { opacity: .5; cursor: not-allowed; }
`;